export default __webpack_public_path__ + "static/media/features-3.8d5aecc9.jpg";